import { useImpersonate } from '~/composables/impersonate'
import useAuth from '~/store-v2/auth/useAuth'
import { useImpersonateStore } from '~/store/impersonate'

// Admin uses the impersonated partner; other profiles use their own.
export function useMyWalletPartner() {
  const { data: auth } = useAuth()
  const impersonateStore = useImpersonateStore()

  const { checkIsImpersonate } = useImpersonate()

  const userProfile = computed(() => auth.value?.me?.perfil)

  // Restores the impersonation saved in localStorage, e.g. after a reload straight on this page.
  watch(userProfile, (profile) => {
    if (profile === 'admin')
      checkIsImpersonate()
  }, { immediate: true })

  const partnerId = computed(() => {
    if (userProfile.value === 'admin' && impersonateStore.partnerId > 0) {
      return impersonateStore.partnerId.toString()
    }
    return auth.value?.person?.partner?.id?.toString() || ''
  })

  const isAdminNotImpersonating = computed(() => {
    return userProfile.value === 'admin' && !impersonateStore.verifyIsImpersonated()
  })

  function openImpersonateModal() {
    impersonateStore.toggleImpersonateModal()
  }

  return {
    partnerId,
    isAdminNotImpersonating,
    openImpersonateModal,
  }
}
